export default class CartIcon {

    constructor($view) {
        this.$view = $view;
        this.$cartIcon = this.$view.find('.js-cart-icon');
        this.bind()
    }

    bind() {
        if (window.innerWidth < 1000) {
            return
        }
        var cart = this.$cartIcon
        this.$cartIcon.each(function() {
            var $this = $(this);
            $this.on('mouseover',function() {     // Avoids flashing
                $this.popover('show');
            });
        });

        $(cart).on('inserted.bs.popover', function () {
            window.addEventListener('mouseover',function(e) {
                var container = document.getElementsByClassName('cart-popover-container')
                if (container.length === 0) {
                    return
                }
                var popover = container[0].closest('.popover')
                var header = document.getElementById('nav-menu')

                if (popover) {
                    if (!popover.contains(e.target) && !header.contains(e.target) && header !== e.target && popover !== e.target) {
                        cart.popover('hide');
                        if (popover.classList.contains('show')) {
                            popover.remove();
                        }
                    }
                }
            });
        })
    }
}